// Where the frontend reaches the Node backend (Render). Every module that
// builds a backend URL takes it from here.

// Used when the variables below are unset. Production sets VITE_API_URL to
// this same origin.
const DEFAULT_BACKEND_ORIGIN = "https://connective-dbr.onrender.com";

// Backend origin, without a trailing /api. VITE_API_URL is an ORIGIN
// (e.g. http://localhost:3000), never a base path.
const API_ORIGIN: string = import.meta.env.VITE_API_URL || DEFAULT_BACKEND_ORIGIN;

// The /api base every backend route sits under.
export const API_BASE_URL = API_ORIGIN + "/api";

// The Render origin api/http.ts health-checks, and the backend it falls back
// to when its base URL points at Supabase. Independent of VITE_API_URL.
export const RENDER_URL: string = import.meta.env.VITE_RENDER_URL || DEFAULT_BACKEND_ORIGIN;
